/* eslint-disable @typescript-eslint/no-explicit-any */
import { useStrings } from "../../../localization/localizationHelpers";

export type ReadOnlyFormItem = {
  title?: string;
  mapper?: (
    _data: any,
    _localizedStrings: Map<string, string>,
    _additionalData?: Map<string, any>
  ) => any;
  isAnswerWithHtmlContent?: boolean;
};

export const useGenerateLocalizedStringsMap = (strings: string[]): Map<string, string> => {
  const translatedStringsArray = useStrings(...strings);

  const translatedStringsMap = new Map<string, string>();
  for (let i = 0; i < strings.length; i++) {
    translatedStringsMap.set(strings[i], translatedStringsArray[i]);
  }

  return translatedStringsMap;
};

export const getDateStringForReadOnlyForm = (date: string) => {
  if (!date) {
    return "";
  }

  const dateArray = date.split("-");
  return `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`;
};
